<template>
  <transition name="fade">
    <div v-show="isShow" class="box-window">
      <div class="closeBox">
        <div @click="close" class="close">X</div>
      </div>
      <div class="cooperation-form container">
        <Form
          ref="form"
          :model="form"
          :rules="ruleValidate"
          :label-width="172"
          @submit.native.prevent="handleSubmit"
          style="padding: 40px 60px 0 50px"
          class="form"
        >
          <Row :gutter="20">
            <Col :span="12">
              <FormItem label="您的姓名" prop="name">
                <Input v-model="form.name" :maxlength="30" placeholder="请输入您的姓名"></Input>
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem label="联系方式" prop="phone">
                <Input
                  v-model="form.phone"
                  :maxlength="20"
                  placeholder="请输入您的电话号码"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="20">
            <Col span="8">
              <FormItem label="意向合作城市" prop="province">
                <Select
                  v-model="form.province"
                  placeholder="选择省份"
                  @on-change="handleProvinceChange"
                  filterable
                >
                  <Option
                    v-for="item in provinceList"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <div class="city">
                <FormItem prop="city">
                  <Select
                    v-model="form.city"
                    placeholder="选择城市"
                    @on-change="handleCityChange"
                    :disabled="!form.province"
                    filterable
                  >
                    <Option
                      v-for="item in cityList"
                      :value="item.value"
                      :key="item.value"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </div>
            </Col>
            <Col span="8">
              <div class="district">
                <FormItem prop="district">
                  <Select
                    v-model="form.district"
                    placeholder="选择地区"
                    :disabled="!form.city"
                    filterable
                  >
                    <Option
                      v-for="item in areaList"
                      :value="item.value"
                      :key="item.value"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </div>
            </Col>
          </Row>
          <FormItem label="备注留言" prop="remark">
            <Input v-model="form.remark" :maxlength="500" type="textarea" placeholder=""></Input>
          </FormItem>
          <div class="submit">
            <FormItem>
              <Button
                type="primary"
                html-type="submit"
                :loading="isSubmitting"
                :disabled="isSubmitting"
              >{{ isSubmitting ? "提交中..." : "提交信息" }}</Button>
            </FormItem>
          </div>
        </Form>
      </div>
    </div>
  </transition>
</template>

<script>
import { getListProvince, getListCity, getListArea } from "@/api/region.js";
import { cooperationInformationData } from "@/api/affiliationIntention.js";
import {
  getRegionName,
  isSubmitSuccess,
  normalizeText,
  shouldShowSubmitError,
  validatePhone,
} from "@/util/form.js";
export default {
  name: "PopupWindow",
  props: {
    isShow: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      provinceList: [],
      cityList: [],
      areaList: [],
      isSubmitting: false,
      form: {
        name: "",
        phone: "",
        province: "",
        city: "",
        district: "",
        remark: "",
      },
      ruleValidate: {
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        phone: [
          { validator: validatePhone, trigger: "blur" },
        ],
        province: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        district: [
          { required: true, message: "请选择地区", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.listProvince();
  },
  methods: {
    close() {
      this.resetForm();
      this.$emit("close", false);
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      this.cityList = [];
      this.areaList = [];
    },
    async listProvince() {
      try {
        const res = await getListProvince();
        this.provinceList = res.data;
      } catch (error) {
        // 错误信息由请求层统一提示。
      }
    },
    async listCity(provinceId) {
      try {
        const res = await getListCity(provinceId);
        if (this.form.province === provinceId) {
          this.cityList = res.data;
        }
      } catch (error) {
        // 错误信息由请求层统一提示。
      }
    },
    async listArea(cityId) {
      try {
        const res = await getListArea(cityId);
        if (this.form.city === cityId) {
          this.areaList = res.data;
        }
      } catch (error) {
        // 错误信息由请求层统一提示。
      }
    },
    handleProvinceChange(value) {
      this.form.city = "";
      this.form.district = "";
      this.cityList = [];
      this.areaList = [];
      if (value) {
        this.listCity(value);
      }
    },
    handleCityChange(value) {
      this.form.district = "";
      this.areaList = [];
      if (value) {
        this.listArea(value);
      }
    },
    async handleSubmit() {
      if (this.isSubmitting) {
        return;
      }

      const valid = await this.$refs.form.validate();
      if (!valid) {
        this.$Message.error("请完整填写表单信息");
        return;
      }

      const form = {
        province: getRegionName(this.provinceList, this.form.province),
        city: getRegionName(this.cityList, this.form.city),
        district: getRegionName(this.areaList, this.form.district),
        name: normalizeText(this.form.name),
        phone: normalizeText(this.form.phone),
        remark: normalizeText(this.form.remark),
      };

      if (!form.province || !form.city || !form.district) {
        this.$Message.error("地区信息已变化，请重新选择");
        return;
      }

      this.isSubmitting = true;
      try {
        const res = await cooperationInformationData(form);

        if (!isSubmitSuccess(res)) {
          if (shouldShowSubmitError(res)) {
            this.$Message.error("提交失败，请稍后重试");
          }
          return;
        }

        this.$Message.success("提交成功，我们会尽快与您联系");
        this.close();
      } catch (error) {
        if (!error || !error.messageShown) {
          this.$Message.error("提交失败，请稍后重试");
        }
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
/* 定义进入的开始状态和离开的结束状态 */
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
/* 最外层 */
.box-window {
  background: url(../assets/img/弹窗背景.png) no-repeat center center;
  background-size: cover;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
  width: 880px;
  height: 594px;
}

/* 关闭按钮 */
.closeBox {
  height: 82px;
  width: 100%;
}
.close {
  width: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 50%;
  line-height: 40px;
  text-align: center;
  margin: 21px 20px;
  opacity: 1;
  font-size: 25px;
  color: #fb575f;
}
/* 表单 */
.cooperation-form {
  width: 880px;
  height: 594px;
  margin-top: 0px;
}
/* title */
>>> .ivu-form-item-label {
  float: none;
  text-align: left !important;
  font-size: 18px !important;
  color: #333 !important;
  font-weight: 400 !important;
}
/* content */
>>> .ivu-form-item-content {
  margin-left: 0px !important;
}
/* 城市输入框 */
.city >>> .ivu-form-item-required {
  margin-top: 43px;
}
.district >>> .ivu-form-item-required {
  margin-top: 43px;
}
/* 留言 */
>>> textarea.ivu-input {
  min-height: 125px !important;
}
/* 提交按钮 */
.submit >>> .ivu-form-item-content {
  text-align: center;
}
.submit >>> .ivu-btn-primary {
  font-size: 18px;
  width: 300px;
  height: 45px;
  background: #fa3636;
  border-radius: 8px;
  border-color: #fa3636;
  margin-top: 15px;
}
@media screen and (max-width: 768px) {
  .box-window {
    width: 320px !important;
    height: 280px !important;
    border-radius: 6px;
  }
  .closeBox {
    height: 39px;
  }
  .close {
    width: 20px;
    height: 20px;
    line-height: 20px;
    margin: 10px 10px;
    font-size: 16px;
  }
  .cooperation-form form {
    padding: 0 !important;
    width: 300px;
  }
  >>> .ivu-form-item-label {
    font-size: 12px !important;
    padding: 10px 0 0 !important;
  }
  .ivu-form-item {
    margin-bottom: 0 !important;
  }
  .city,
  .district {
    margin-top: -16px;
  }
  >>> textarea.ivu-input {
    min-height: 55px !important;
  }
  .submit >>> .ivu-btn-primary {
    line-height: 15px;
    font-size: 12px;
    width: 100px;
    height: 25px;
    margin-top: 8px;
  }
  >>> .ivu-form-item-error-tip {
    top: 81% !important;
    font-size: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PopupWindow.vue